import { green, red } from '@jupiterone/jupiter-web-toolkit';

const getVisEdgeColor = ({ displayName }: { displayName?: string }) => {
  if (displayName?.toLowerCase().includes('allows')) {
    return green[700];
  }
  if (displayName?.toLowerCase().includes('denies')) {
    return red[400];
  }
  return undefined;
};

export default getVisEdgeColor;
